import type { StructuredMethodology } from './methodologyContentProps';

export function buildElectricityPricesVerifiedMethodology(): StructuredMethodology {
  return {
    primarySources: [
      'U.S. Energy Information Administration Form EIA-861, Sales to Ultimate Customers (revenue and retail sales by utility, state, and customer class).',
    ],
    calculation: [
      'Average revenue per kWh = reported customer-class revenue ÷ reported customer-class electricity sales (MWh converted to kWh).',
      'When a community choice aggregator begins service, the time series uses the prior investor-owned utility before the documented CCA start year and CCA-reported values from the start year onward where EIA data exist.',
    ],
    limitations: [
      'Average revenue per kWh is not a tariff schedule or marginal electricity rate.',
      'Utility or CCA territory averages are not necessarily the price faced by customers within city boundaries.',
      'Does not capture individual rate plans, fixed charges, discounts, time-of-use rates, or household bills.',
    ],
    technicalDetails: [
      'electricity_prices_by_geography',
      'electricity_utility_crosswalk',
      'ccas',
      'electricityPricesByGeographyService.ts',
      'ElectricityPricesByGeographyChart.tsx',
    ],
  };
}
